import { inject, Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LoadingComponent } from '@portal/loading/ui';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly overlay = inject(Overlay);
  private readonly loadingRef = this.createCdkLoading();

  show(): void {
    if (!this.loadingRef.hasAttached()) {
      this.loadingRef.attach(new ComponentPortal(LoadingComponent));
    }
  }

  hide(): void {
    this.loadingRef.detach();
  }

  private createCdkLoading(): OverlayRef {
    return this.overlay.create({
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true,
    });
  }
}
